import { GET_CELEBRATION_BY_IDENTITY } from '../graphql'
import { GetCelebrationByIdentityResponse } from './useGetCelebrationByIdentity'
import { useQuery } from '@apollo/client'

export interface YbCelebrationByIdentityInput {
  input: {
    identityUuid: string
  }
}

export const useGetExistingCelebrationData = (identityUuid?: string) => {
  const { loading, error, data, refetch } = useQuery<
    GetCelebrationByIdentityResponse | undefined
  >(GET_CELEBRATION_BY_IDENTITY, {
    variables: { input: { identityUuid } },
    errorPolicy: 'all',
    skip: !identityUuid,
  })

  return { loading, error, data, refetch }
}
